"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function RectangleXlMobileSvg(t0) {
  const $ = _c(285);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path opacity={0.7} d="M740 652L740 975L161.479 975C72.2768 975 1.20977e-05 902.682 8.20031e-06 813.521C4.30297e-06 724.36 72.3184 652 161.479 652L740 652Z" fill="#4668C2" style={style("center right")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path opacity={0.4} d="M-350 975L-350 1298L228.521 1298C317.723 1298 390 1225.68 390 1136.52C390 1047.36 317.682 975 228.521 975L-350 975Z" fill="#4668C2" style={style("center left")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== style) {
          t9 = <motion.path opacity={0.7} d="M323 -88H3.85046e-05L0 490.521C0 579.723 72.3184 652 161.479 652C250.64 652 323 579.682 323 490.521L323 -88Z" fill="#4668C2" style={style("top center")} />;
          $[11] = style;
          $[12] = t9;
        } else {
          t9 = $[12];
        }
        let t10;
        if ($[13] !== style) {
          t10 = <motion.path opacity={0.4} d="M2.68599e-05 2361L323 2361L323 1782.48C323 1693.28 250.682 1621 161.521 1621C72.3601 1621 0.000115748 1693.32 0.000107953 1782.48L2.68599e-05 2361Z" fill="#4668C2" style={style("bottom center")} />;
          $[13] = style;
          $[14] = t10;
        } else {
          t10 = $[14];
        }
        let t11;
        if ($[15] !== style) {
          t11 = <motion.circle opacity={0.7} cx="297.573" cy="1472.57" r="174.573" fill="#4668C2" style={style("center center")} />;
          $[15] = style;
          $[16] = t11;
        } else {
          t11 = $[16];
        }
        let t12;
        if ($[17] !== t10 || $[18] !== t11 || $[19] !== t5 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[17] = t10;
          $[18] = t11;
          $[19] = t5;
          $[20] = t7;
          $[21] = t8;
          $[22] = t9;
          $[23] = t12;
        } else {
          t12 = $[23];
        }
        let t13;
        if ($[24] !== t12 || $[25] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[24] = t12;
          $[25] = t4;
          $[26] = t13;
        } else {
          t13 = $[26];
        }
        return t13;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[27] = t3;
        } else {
          t3 = $[27];
        }
        let t4;
        if ($[28] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[28] = t2;
          $[29] = t4;
        } else {
          t4 = $[29];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#9BD7D2" />;
          $[30] = t6;
        } else {
          t6 = $[30];
        }
        let t7;
        if ($[31] !== style) {
          t7 = <motion.path opacity={0.7} d="M740 652L740 975L161.479 975C72.2768 975 -3.16114e-06 902.682 -7.05848e-06 813.521C-1.09558e-05 724.36 72.3184 652 161.479 652L740 652Z" fill="#85CDC7" style={style("center right")} />;
          $[31] = style;
          $[32] = t7;
        } else {
          t7 = $[32];
        }
        let t8;
        if ($[33] !== style) {
          t8 = <motion.path opacity={0.5} d="M-350 975L-350 1298L228.521 1298C317.723 1298 390 1225.68 390 1136.52C390 1047.36 317.682 975 228.521 975L-350 975Z" fill="#85CDC7" style={style("center left")} />;
          $[33] = style;
          $[34] = t8;
        } else {
          t8 = $[34];
        }
        let t9;
        if ($[35] !== style) {
          t9 = <motion.path opacity={0.5} d="M323 -88H3.85046e-05L0 490.521C0 579.723 72.3184 652 161.479 652C250.64 652 323 579.682 323 490.521L323 -88Z" fill="#85CDC7" style={style("top center")} />;
          $[35] = style;
          $[36] = t9;
        } else {
          t9 = $[36];
        }
        let t10;
        if ($[37] !== style) {
          t10 = <motion.path opacity={0.5} d="M2.68599e-05 2361L323 2361L323 1782.48C323 1693.28 250.682 1621 161.521 1621C72.3601 1621 0.000115748 1693.32 0.000107953 1782.48L2.68599e-05 2361Z" fill="#85CDC7" style={style("bottom center")} />;
          $[37] = style;
          $[38] = t10;
        } else {
          t10 = $[38];
        }
        let t11;
        if ($[39] !== style) {
          t11 = <motion.circle opacity={0.7} cx="297.573" cy="1472.57" r="174.573" fill="#85CDC7" style={style("center center")} />;
          $[39] = style;
          $[40] = t11;
        } else {
          t11 = $[40];
        }
        let t12;
        if ($[41] !== t10 || $[42] !== t11 || $[43] !== t5 || $[44] !== t7 || $[45] !== t8 || $[46] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[41] = t10;
          $[42] = t11;
          $[43] = t5;
          $[44] = t7;
          $[45] = t8;
          $[46] = t9;
          $[47] = t12;
        } else {
          t12 = $[47];
        }
        let t13;
        if ($[48] !== t12 || $[49] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[48] = t12;
          $[49] = t4;
          $[50] = t13;
        } else {
          t13 = $[50];
        }
        return t13;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[51] = t3;
        } else {
          t3 = $[51];
        }
        let t4;
        if ($[52] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[52] = t2;
          $[53] = t4;
        } else {
          t4 = $[53];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#00968C" />;
          $[54] = t6;
        } else {
          t6 = $[54];
        }
        let t7;
        if ($[55] !== style) {
          t7 = <motion.rect opacity={0.65} x="195.146" y="1164" width="349.146" height="349.146" rx="16.4482" fill="#00A399" style={style("bottom right")} />;
          $[55] = style;
          $[56] = t7;
        } else {
          t7 = $[56];
        }
        let t8;
        if ($[57] !== style) {
          t8 = <motion.rect opacity={0.65} x="-154" y="1513" width="349.146" height="349.146" rx="16.4482" fill="#00A399" style={style("center left")} />;
          $[57] = style;
          $[58] = t8;
        } else {
          t8 = $[58];
        }
        let t9;
        if ($[59] !== style) {
          t9 = <motion.rect opacity={0.65} x="195.146" y="1862" width="349.146" height="349.146" rx="16.4482" fill="#00A399" style={style("bottom right")} />;
          $[59] = style;
          $[60] = t9;
        } else {
          t9 = $[60];
        }
        let t10;
        if ($[61] !== style) {
          t10 = <motion.circle cx="369.72" cy="1687.57" r="174.573" fill="#00A399" style={style("center right")} />;
          $[61] = style;
          $[62] = t10;
        } else {
          t10 = $[62];
        }
        let t11;
        if ($[63] !== style) {
          t11 = <motion.circle cx="20.5732" cy="1338.57" r="174.573" fill="#00A399" style={style("center left")} />;
          $[63] = style;
          $[64] = t11;
        } else {
          t11 = $[64];
        }
        let t12;
        if ($[65] !== style) {
          t12 = <motion.circle cx="20.5732" cy="2036.57" r="174.573" fill="#00A399" style={style("bottom left")} />;
          $[65] = style;
          $[66] = t12;
        } else {
          t12 = $[66];
        }
        let t13;
        if ($[67] !== style) {
          t13 = <motion.circle opacity={0.65} cx="192" cy="972" r="192" fill="#00A399" style={style("center center")} />;
          $[67] = style;
          $[68] = t13;
        } else {
          t13 = $[68];
        }
        let t14;
        if ($[69] !== t10 || $[70] !== t11 || $[71] !== t12 || $[72] !== t13 || $[73] !== t5 || $[74] !== t7 || $[75] !== t8 || $[76] !== t9) {
          t14 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}</g>;
          $[69] = t10;
          $[70] = t11;
          $[71] = t12;
          $[72] = t13;
          $[73] = t5;
          $[74] = t7;
          $[75] = t8;
          $[76] = t9;
          $[77] = t14;
        } else {
          t14 = $[77];
        }
        let t15;
        if ($[78] !== t14 || $[79] !== t4) {
          t15 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t14}</svg>;
          $[78] = t14;
          $[79] = t4;
          $[80] = t15;
        } else {
          t15 = $[80];
        }
        return t15;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[81] = t3;
        } else {
          t3 = $[81];
        }
        let t4;
        if ($[82] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[82] = t2;
          $[83] = t4;
        } else {
          t4 = $[83];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#FFB497" />;
          $[84] = t6;
        } else {
          t6 = $[84];
        }
        let t7;
        if ($[85] !== style) {
          t7 = <motion.path opacity={0.7} d="M219.206 2210.74H2.47161e-05V1991.56C-0.0501942 1897.21 76.4332 1820.74 170.795 1820.74H390V2039.91C390 2134.26 313.517 2210.74 219.155 2210.74" fill="#F8A98A" style={style("bottom left")} />;
          $[85] = style;
          $[86] = t7;
        } else {
          t7 = $[86];
        }
        let t8;
        if ($[87] !== style) {
          t8 = <motion.path opacity={0.7} d="M219.206 1433H2.47161e-05V1213.82C-0.0501942 1119.47 76.4332 1043 170.795 1043H390V1262.18C390 1356.53 313.517 1433 219.155 1433" fill="#F8A98A" style={style("center left")} />;
          $[87] = style;
          $[88] = t8;
        } else {
          t8 = $[88];
        }
        let t9;
        if ($[89] !== style) {
          t9 = <motion.path opacity={0.7} d="M219.206 1823H2.47161e-05V1603.82C-0.0501942 1509.47 76.4332 1433 170.795 1433H390V1652.18C390 1746.53 313.517 1823 219.155 1823" fill="#FFAF8F" style={style("center left")} />;
          $[89] = style;
          $[90] = t9;
        } else {
          t9 = $[90];
        }
        let t10;
        if ($[91] !== style) {
          t10 = <motion.path opacity={0.7} d="M390 823.794L390 1043L170.823 1043C76.4735 1043.05 -3.341e-06 966.567 -7.46567e-06 872.205L-1.70474e-05 653L219.177 653C313.526 653 390 729.483 390 823.845" fill="#FFAF8F" style={style("center right")} />;
          $[91] = style;
          $[92] = t10;
        } else {
          t10 = $[92];
        }
        let t11;
        if ($[93] !== style) {
          t11 = <motion.circle opacity={0.7} cx="192" cy="467" r="192" fill="#FFAF8F" style={style("top center")} />;
          $[93] = style;
          $[94] = t11;
        } else {
          t11 = $[94];
        }
        let t12;
        if ($[95] !== t10 || $[96] !== t11 || $[97] !== t5 || $[98] !== t7 || $[99] !== t8 || $[100] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[95] = t10;
          $[96] = t11;
          $[97] = t5;
          $[98] = t7;
          $[99] = t8;
          $[100] = t9;
          $[101] = t12;
        } else {
          t12 = $[101];
        }
        let t13;
        if ($[102] !== t12 || $[103] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[102] = t12;
          $[103] = t4;
          $[104] = t13;
        } else {
          t13 = $[104];
        }
        return t13;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[105] = t3;
        } else {
          t3 = $[105];
        }
        let t4;
        if ($[106] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[106] = t2;
          $[107] = t4;
        } else {
          t4 = $[107];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#CCE88A" />;
          $[108] = t6;
        } else {
          t6 = $[108];
        }
        let t7;
        if ($[109] !== style) {
          t7 = <motion.path d="M459 1105.5L99.5 1465L459 1824.5L818.5 1465L459 1105.5Z" fill="#C2E079" style={style("center right")} />;
          $[109] = style;
          $[110] = t7;
        } else {
          t7 = $[110];
        }
        let t8;
        if ($[111] !== style) {
          t8 = <motion.path d="M80.5 1492L-279 1851.5L80.5 2211L440 1851.5L80.5 1492Z" fill="#C2E079" style={style("bottom left")} />;
          $[111] = style;
          $[112] = t8;
        } else {
          t8 = $[112];
        }
        let t9;
        if ($[113] !== style) {
          t9 = <motion.path d="M99.5 702.801L-260 1062.3L99.5 1421.8L459 1062.3L99.5 702.801Z" fill="#C6E57D" style={style("center center")} />;
          $[113] = style;
          $[114] = t9;
        } else {
          t9 = $[114];
        }
        let t10;
        if ($[115] !== t5 || $[116] !== t7 || $[117] !== t8 || $[118] !== t9) {
          t10 = <g clipPath={t5}>{t6}{t7}{t8}{t9}</g>;
          $[115] = t5;
          $[116] = t7;
          $[117] = t8;
          $[118] = t9;
          $[119] = t10;
        } else {
          t10 = $[119];
        }
        let t11;
        if ($[120] !== t10 || $[121] !== t4) {
          t11 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t10}</svg>;
          $[120] = t10;
          $[121] = t4;
          $[122] = t11;
        } else {
          t11 = $[122];
        }
        return t11;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[123] = t3;
        } else {
          t3 = $[123];
        }
        let t4;
        if ($[124] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[124] = t2;
          $[125] = t4;
        } else {
          t4 = $[125];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#A6B9F1" />;
          $[126] = t6;
        } else {
          t6 = $[126];
        }
        let t7;
        if ($[127] !== style) {
          t7 = <motion.path d="M218.081 2211H2.45893e-05V1992.95C-0.0499368 1899.08 76.0413 1823 169.919 1823H388V2041.05C388 2134.92 311.909 2211 218.031 2211" fill="#90A7E7" style={style("bottom left")} />;
          $[127] = style;
          $[128] = t7;
        } else {
          t7 = $[128];
        }
        let t8;
        if ($[129] !== style) {
          t8 = <motion.path d="M218.081 1435H2.45893e-05V1216.95C-0.0499368 1123.08 76.0413 1047 169.919 1047H388V1265.05C388 1358.92 311.909 1435 218.031 1435" fill="#90A7E7" style={style("center left")} />;
          $[129] = style;
          $[130] = t8;
        } else {
          t8 = $[130];
        }
        let t9;
        if ($[131] !== style) {
          t9 = <motion.path d="M218.081 1823H2.45893e-05V1604.95C-0.0499368 1511.08 76.0413 1435 169.919 1435H388V1653.05C388 1746.92 311.909 1823 218.031 1823" fill="#9BB1EF" style={style("center left")} />;
          $[131] = style;
          $[132] = t9;
        } else {
          t9 = $[132];
        }
        let t10;
        if ($[133] !== style) {
          t10 = <motion.path d="M388 828.919L388 1047L169.947 1047C76.0814 1047.05 -3.32387e-06 970.959 -7.42738e-06 877.081L-1.696e-05 659L218.053 659C311.919 659 388 735.091 388 828.969" fill="#9BB1EF" style={style("center right")} />;
          $[133] = style;
          $[134] = t10;
        } else {
          t10 = $[134];
        }
        let t11;
        if ($[135] !== style) {
          t11 = <motion.circle cx="192" cy="467" r="192" fill="#9BB1EF" style={style("top center")} />;
          $[135] = style;
          $[136] = t11;
        } else {
          t11 = $[136];
        }
        let t12;
        if ($[137] !== t10 || $[138] !== t11 || $[139] !== t5 || $[140] !== t7 || $[141] !== t8 || $[142] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[137] = t10;
          $[138] = t11;
          $[139] = t5;
          $[140] = t7;
          $[141] = t8;
          $[142] = t9;
          $[143] = t12;
        } else {
          t12 = $[143];
        }
        let t13;
        if ($[144] !== t12 || $[145] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[144] = t12;
          $[145] = t4;
          $[146] = t13;
        } else {
          t13 = $[146];
        }
        return t13;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[147] = t3;
        } else {
          t3 = $[147];
        }
        let t4;
        if ($[148] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[148] = t2;
          $[149] = t4;
        } else {
          t4 = $[149];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[150] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#F0B464" />;
          $[150] = t6;
        } else {
          t6 = $[150];
        }
        let t7;
        if ($[151] !== style) {
          t7 = <motion.path opacity={0.6} d="M740 652L740 975L161.479 975C72.2768 975 1.20977e-05 902.682 8.20031e-06 813.521C4.30297e-06 724.36 72.3184 652 161.479 652L740 652Z" fill="#EFAC53" style={style("center right")} />;
          $[151] = style;
          $[152] = t7;
        } else {
          t7 = $[152];
        }
        let t8;
        if ($[153] !== style) {
          t8 = <motion.path d="M-350 975L-350 1298L228.521 1298C317.723 1298 390 1225.68 390 1136.52C390 1047.36 317.682 975 228.521 975L-350 975Z" fill="#EFAC53" style={style("center left")} />;
          $[153] = style;
          $[154] = t8;
        } else {
          t8 = $[154];
        }
        let t9;
        if ($[155] !== style) {
          t9 = <motion.path d="M323 -88H3.85046e-05L0 490.521C0 579.723 72.3184 652 161.479 652C250.64 652 323 579.682 323 490.521L323 -88Z" fill="#EFAC53" style={style("top center")} />;
          $[155] = style;
          $[156] = t9;
        } else {
          t9 = $[156];
        }
        let t10;
        if ($[157] !== style) {
          t10 = <motion.path opacity={0.6} d="M2.68599e-05 2361L323 2361L323 1782.48C323 1693.28 250.682 1621 161.521 1621C72.3601 1621 0.000115748 1693.32 0.000107953 1782.48L2.68599e-05 2361Z" fill="#EFAC53" style={style("bottom center")} />;
          $[157] = style;
          $[158] = t10;
        } else {
          t10 = $[158];
        }
        let t11;
        if ($[159] !== style) {
          t11 = <motion.circle opacity={0.6} cx="297.573" cy="1472.57" r="174.573" fill="#EFAC53" style={style("center center")} />;
          $[159] = style;
          $[160] = t11;
        } else {
          t11 = $[160];
        }
        let t12;
        if ($[161] !== t10 || $[162] !== t11 || $[163] !== t5 || $[164] !== t7 || $[165] !== t8 || $[166] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[161] = t10;
          $[162] = t11;
          $[163] = t5;
          $[164] = t7;
          $[165] = t8;
          $[166] = t9;
          $[167] = t12;
        } else {
          t12 = $[167];
        }
        let t13;
        if ($[168] !== t12 || $[169] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[168] = t12;
          $[169] = t4;
          $[170] = t13;
        } else {
          t13 = $[170];
        }
        return t13;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[171] = t3;
        } else {
          t3 = $[171];
        }
        let t4;
        if ($[172] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[172] = t2;
          $[173] = t4;
        } else {
          t4 = $[173];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#007190" />;
          $[174] = t6;
        } else {
          t6 = $[174];
        }
        let t7;
        if ($[175] !== style) {
          t7 = <motion.path opacity={0.7} d="M740 652L740 975L161.479 975C72.2768 975 -3.16114e-06 902.682 -7.05848e-06 813.521C-1.09558e-05 724.36 72.3184 652 161.479 652L740 652Z" fill="#008AAA" style={style("center right")} />;
          $[175] = style;
          $[176] = t7;
        } else {
          t7 = $[176];
        }
        let t8;
        if ($[177] !== style) {
          t8 = <motion.path opacity={0.4} d="M-350 975L-350 1298L228.521 1298C317.723 1298 390 1225.68 390 1136.52C390 1047.36 317.682 975 228.521 975L-350 975Z" fill="#008AAA" style={style("center left")} />;
          $[177] = style;
          $[178] = t8;
        } else {
          t8 = $[178];
        }
        let t9;
        if ($[179] !== style) {
          t9 = <motion.path opacity={0.4} d="M323 -88H3.85046e-05L0 490.521C0 579.723 72.3184 652 161.479 652C250.64 652 323 579.682 323 490.521L323 -88Z" fill="#008AAA" style={style("top center")} />;
          $[179] = style;
          $[180] = t9;
        } else {
          t9 = $[180];
        }
        let t10;
        if ($[181] !== style) {
          t10 = <motion.path opacity={0.4} d="M2.68599e-05 2361L323 2361L323 1782.48C323 1693.28 250.682 1621 161.521 1621C72.3601 1621 0.000115748 1693.32 0.000107953 1782.48L2.68599e-05 2361Z" fill="#008AAA" style={style("bottom center")} />;
          $[181] = style;
          $[182] = t10;
        } else {
          t10 = $[182];
        }
        let t11;
        if ($[183] !== style) {
          t11 = <motion.circle opacity={0.7} cx="297.573" cy="1472.57" r="174.573" fill="#008AAA" style={style("center center")} />;
          $[183] = style;
          $[184] = t11;
        } else {
          t11 = $[184];
        }
        let t12;
        if ($[185] !== t10 || $[186] !== t11 || $[187] !== t5 || $[188] !== t7 || $[189] !== t8 || $[190] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[185] = t10;
          $[186] = t11;
          $[187] = t5;
          $[188] = t7;
          $[189] = t8;
          $[190] = t9;
          $[191] = t12;
        } else {
          t12 = $[191];
        }
        let t13;
        if ($[192] !== t12 || $[193] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[192] = t12;
          $[193] = t4;
          $[194] = t13;
        } else {
          t13 = $[194];
        }
        return t13;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[195] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[195] = t3;
        } else {
          t3 = $[195];
        }
        let t4;
        if ($[196] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[196] = t2;
          $[197] = t4;
        } else {
          t4 = $[197];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[198] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#86CD9F" />;
          $[198] = t6;
        } else {
          t6 = $[198];
        }
        let t7;
        if ($[199] !== style) {
          t7 = <motion.path d="M218.081 2211H2.45893e-05V1992.95C-0.0499368 1899.08 76.0413 1823 169.919 1823H388V2041.05C388 2134.92 311.909 2211 218.031 2211" fill="#77C793" style={style("bottom left")} />;
          $[199] = style;
          $[200] = t7;
        } else {
          t7 = $[200];
        }
        let t8;
        if ($[201] !== style) {
          t8 = <motion.path d="M218.081 1435H2.45893e-05V1216.95C-0.0499368 1123.08 76.0413 1047 169.919 1047H388V1265.05C388 1358.92 311.909 1435 218.031 1435" fill="#77C793" style={style("center left")} />;
          $[201] = style;
          $[202] = t8;
        } else {
          t8 = $[202];
        }
        let t9;
        if ($[203] !== style) {
          t9 = <motion.path opacity={0.6} d="M218.081 1823H2.45893e-05V1604.95C-0.0499368 1511.08 76.0413 1435 169.919 1435H388V1653.05C388 1746.92 311.909 1823 218.031 1823" fill="#77C793" style={style("center left")} />;
          $[203] = style;
          $[204] = t9;
        } else {
          t9 = $[204];
        }
        let t10;
        if ($[205] !== style) {
          t10 = <motion.path opacity={0.6} d="M388 828.919L388 1047L169.947 1047C76.0814 1047.05 -3.32387e-06 970.959 -7.42738e-06 877.081L-1.696e-05 659L218.053 659C311.919 659 388 735.091 388 828.969" fill="#77C793" style={style("center right")} />;
          $[205] = style;
          $[206] = t10;
        } else {
          t10 = $[206];
        }
        let t11;
        if ($[207] !== style) {
          t11 = <motion.circle cx="192" cy="467" r="192" fill="#77C793" style={style("top center")} />;
          $[207] = style;
          $[208] = t11;
        } else {
          t11 = $[208];
        }
        let t12;
        if ($[209] !== t10 || $[210] !== t11 || $[211] !== t5 || $[212] !== t7 || $[213] !== t8 || $[214] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[209] = t10;
          $[210] = t11;
          $[211] = t5;
          $[212] = t7;
          $[213] = t8;
          $[214] = t9;
          $[215] = t12;
        } else {
          t12 = $[215];
        }
        let t13;
        if ($[216] !== t12 || $[217] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[216] = t12;
          $[217] = t4;
          $[218] = t13;
        } else {
          t13 = $[218];
        }
        return t13;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[219] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[219] = t3;
        } else {
          t3 = $[219];
        }
        let t4;
        if ($[220] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[220] = t2;
          $[221] = t4;
        } else {
          t4 = $[221];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[222] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#FFD152" />;
          $[222] = t6;
        } else {
          t6 = $[222];
        }
        let t7;
        if ($[223] !== style) {
          t7 = <motion.path d="M459 1105.5L99.5 1465L459 1824.5L818.5 1465L459 1105.5Z" fill="#FFCC3D" style={style("center right")} />;
          $[223] = style;
          $[224] = t7;
        } else {
          t7 = $[224];
        }
        let t8;
        if ($[225] !== style) {
          t8 = <motion.path d="M80.5 1492L-279 1851.5L80.5 2211L440 1851.5L80.5 1492Z" fill="#FFCC3D" style={style("bottom left")} />;
          $[225] = style;
          $[226] = t8;
        } else {
          t8 = $[226];
        }
        let t9;
        if ($[227] !== style) {
          t9 = <motion.path opacity={0.5} d="M99.5 702.801L-260 1062.3L99.5 1421.8L459 1062.3L99.5 702.801Z" fill="#FFCC3D" style={style("center center")} />;
          $[227] = style;
          $[228] = t9;
        } else {
          t9 = $[228];
        }
        let t10;
        if ($[229] !== t5 || $[230] !== t7 || $[231] !== t8 || $[232] !== t9) {
          t10 = <g clipPath={t5}>{t6}{t7}{t8}{t9}</g>;
          $[229] = t5;
          $[230] = t7;
          $[231] = t8;
          $[232] = t9;
          $[233] = t10;
        } else {
          t10 = $[233];
        }
        let t11;
        if ($[234] !== t10 || $[235] !== t4) {
          t11 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t10}</svg>;
          $[234] = t10;
          $[235] = t4;
          $[236] = t11;
        } else {
          t11 = $[236];
        }
        return t11;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[237] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[237] = t3;
        } else {
          t3 = $[237];
        }
        let t4;
        if ($[238] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[238] = t2;
          $[239] = t4;
        } else {
          t4 = $[239];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[240] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#2B52B8" />;
          $[240] = t6;
        } else {
          t6 = $[240];
        }
        let t7;
        if ($[241] !== style) {
          t7 = <motion.path opacity={0.7} d="M740 652L740 975L161.479 975C72.2768 975 -3.16114e-06 902.682 -7.05848e-06 813.521C-1.09558e-05 724.36 72.3184 652 161.479 652L740 652Z" fill="#2F5FD6" style={style("center right")} />;
          $[241] = style;
          $[242] = t7;
        } else {
          t7 = $[242];
        }
        let t8;
        if ($[243] !== style) {
          t8 = <motion.path opacity={0.4} d="M-350 975L-350 1298L228.521 1298C317.723 1298 390 1225.68 390 1136.52C390 1047.36 317.682 975 228.521 975L-350 975Z" fill="#2F5FD6" style={style("center left")} />;
          $[243] = style;
          $[244] = t8;
        } else {
          t8 = $[244];
        }
        let t9;
        if ($[245] !== style) {
          t9 = <motion.path opacity={0.4} d="M323 -88H3.85046e-05L0 490.521C0 579.723 72.3184 652 161.479 652C250.64 652 323 579.682 323 490.521L323 -88Z" fill="#2F5FD6" style={style("top center")} />;
          $[245] = style;
          $[246] = t9;
        } else {
          t9 = $[246];
        }
        let t10;
        if ($[247] !== style) {
          t10 = <motion.path opacity={0.4} d="M-9.52104e-05 2361L323 2361L323 1782.48C323 1693.28 250.682 1621 161.521 1621C72.36 1621 -6.32227e-06 1693.32 -1.4117e-05 1782.48L-9.52104e-05 2361Z" fill="#2F5FD6" style={style("bottom center")} />;
          $[247] = style;
          $[248] = t10;
        } else {
          t10 = $[248];
        }
        let t11;
        if ($[249] !== style) {
          t11 = <motion.circle opacity={0.7} cx="297.573" cy="1472.57" r="174.573" fill="#2F5FD6" style={style("center center")} />;
          $[249] = style;
          $[250] = t11;
        } else {
          t11 = $[250];
        }
        let t12;
        if ($[251] !== t10 || $[252] !== t11 || $[253] !== t5 || $[254] !== t7 || $[255] !== t8 || $[256] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[251] = t10;
          $[252] = t11;
          $[253] = t5;
          $[254] = t7;
          $[255] = t8;
          $[256] = t9;
          $[257] = t12;
        } else {
          t12 = $[257];
        }
        let t13;
        if ($[258] !== t12 || $[259] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[258] = t12;
          $[259] = t4;
          $[260] = t13;
        } else {
          t13 = $[260];
        }
        return t13;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[261] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="2211" fill="white" />;
          $[261] = t3;
        } else {
          t3 = $[261];
        }
        let t4;
        if ($[262] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[262] = t2;
          $[263] = t4;
        } else {
          t4 = $[263];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[264] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="2211" fill="#1A3C82" />;
          $[264] = t6;
        } else {
          t6 = $[264];
        }
        let t7;
        if ($[265] !== style) {
          t7 = <motion.path opacity={0.6} d="M218.081 2211H2.45893e-05V1992.95C-0.0499368 1899.08 76.0413 1823 169.919 1823H388V2041.05C388 2134.92 311.909 2211 218.031 2211" fill="#2A4C97" style={style("bottom left")} />;
          $[265] = style;
          $[266] = t7;
        } else {
          t7 = $[266];
        }
        let t8;
        if ($[267] !== style) {
          t8 = <motion.path d="M218.081 1435H2.45893e-05V1216.95C-0.0499368 1123.08 76.0413 1047 169.919 1047H388V1265.05C388 1358.92 311.909 1435 218.031 1435" fill="#2A4C97" style={style("center left")} />;
          $[267] = style;
          $[268] = t8;
        } else {
          t8 = $[268];
        }
        let t9;
        if ($[269] !== style) {
          t9 = <motion.path opacity={0.6} d="M218.081 1823H2.45893e-05V1604.95C-0.0499368 1511.08 76.0413 1435 169.919 1435H388V1653.05C388 1746.92 311.909 1823 218.031 1823" fill="#2A4C97" style={style("center left")} />;
          $[269] = style;
          $[270] = t9;
        } else {
          t9 = $[270];
        }
        let t10;
        if ($[271] !== style) {
          t10 = <motion.path opacity={0.6} d="M388 828.919L388 1047L169.947 1047C76.0814 1047.05 -3.32387e-06 970.959 -7.42738e-06 877.081L-1.696e-05 659L218.053 659C311.919 659 388 735.091 388 828.969" fill="#2A4C97" style={style("center right")} />;
          $[271] = style;
          $[272] = t10;
        } else {
          t10 = $[272];
        }
        let t11;
        if ($[273] !== style) {
          t11 = <motion.circle cx="192" cy="467" r="192" fill="#2A4C97" style={style("top center")} />;
          $[273] = style;
          $[274] = t11;
        } else {
          t11 = $[274];
        }
        let t12;
        if ($[275] !== t10 || $[276] !== t11 || $[277] !== t5 || $[278] !== t7 || $[279] !== t8 || $[280] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[275] = t10;
          $[276] = t11;
          $[277] = t5;
          $[278] = t7;
          $[279] = t8;
          $[280] = t9;
          $[281] = t12;
        } else {
          t12 = $[281];
        }
        let t13;
        if ($[282] !== t12 || $[283] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 2211" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[282] = t12;
          $[283] = t4;
          $[284] = t13;
        } else {
          t13 = $[284];
        }
        return t13;
      }
    default:
      {
        return null;
      }
  }
}
const RectangleXlMobileColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-[130/737]";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <RectangleXlMobileSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
RectangleXlMobileColorBlock.displayName = "RectangleXlMobileColorBlock";
export { RectangleXlMobileColorBlock };